module.exports = __webpack_public_path__ + "img/reset-stamp.1bab2a43.svg";